(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        $(document).ready(function () {
            var $hotCitySelect = new hSelect({
                selector: ".hot-city-select",
                theme: "easy",
                checkWidth: false,
                onChange: function onChange(ui) {},
                onItemClick: function onItemClick($elem) {
                    var val = $elem.data("value");
                    if (val !== this.value) {
                        var view = $elem.find("a").html();
                        if ("undefined" != typeof $elem.data("text") && "" != $elem.data("text")) {
                            view = "<span>" + $elem.data("text") + "</span>";
                        }
                        this.$items.find(".h-select-item__active").removeClass("h-select-item__active");
                        $elem.addClass("h-select-item__active");
                        this.onChange(val, view, $elem);
                    }
                    this.hide();
                }
            });

            var $hotCountrySelect = new hSelect({
                selector: ".hot-country-select",
                theme: "easy",
                checkWidth: false,
                onChange: function onChange(ui) {},
                onItemClick: function onItemClick($elem) {
                    var val = $elem.data("value");
                    if (val !== this.value) {
                        var view = $elem.find("a").html();
                        var img = $elem.data("img");
                        if ("undefined" != typeof $elem.data("text") && "" != $elem.data("text")) {
                            view = '<span><img src="' + img + '">' + $elem.data("text") + '</span>';
                        }
                        this.$items.find(".h-select-item__active").removeClass("h-select-item__active");
                        $elem.addClass("h-select-item__active");
                        this.onChange(val, view, $elem);
                    }
                    this.hide();
                }
            });

            var $hotGroupSelect = new hSelect({
                selector: ".hot-group-select",
                theme: "easy",
                checkWidth: false,
                onChange: function onChange(ui) {},
                onItemClick: function onItemClick($elem) {
                    var val = $elem.data("value");
                    if (val !== this.value) {
                        var view = $elem.find("a").html();
                        if ("undefined" != typeof $elem.data("text") && "" != $elem.data("text")) {
                            view = '<span>' + $elem.data("text") + '</span>';
                        }
                        this.$items.find(".h-select-item__active").removeClass("h-select-item__active");
                        $elem.addClass("h-select-item__active");
                        this.onChange(val, view, $elem);
                    }
                    this.hide();
                }
            });
        });
    }, {}] }, {}, [1]);